import { render, staticRenderFns } from "./MaterialLoss.vue?vue&type=template&id=50d4722a"
import script from "./MaterialLoss.vue?vue&type=script&lang=js"
export * from "./MaterialLoss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports